import { useState } from "react";
import Image from "../../Home/components/Image";
import { HomeBuiltInDeckBare, HomeChannelCards } from "../../Home/components/HomeChannels";

const VIEWS = [
  { id: "front", label: "Front office" },
  { id: "back", label: "Back office" },
];

/* rentDirect as a full-bleed band, mirroring the rentAI layout: rounded top corners, logo on top,
   title left / subcopy right, then the home page's channel cards (front office) or the
   "everything built in" deck (back office) underneath. */
export function TntRentDirectBand({ gradient }) {
  const [view, setView] = useState("front");

  return (
    <div
      className="relative left-1/2 w-screen -translate-x-1/2 overflow-hidden rounded-t-[28px] sm:rounded-t-[40px]"
      style={{ backgroundColor: "#050505", backgroundImage: gradient }}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-20 rounded-t-[28px] border border-b-0 border-white/15 sm:rounded-t-[40px]"
        style={{
          WebkitMaskImage: "linear-gradient(to bottom, #000 0%, #000 45%, transparent 80%)",
          maskImage: "linear-gradient(to bottom, #000 0%, #000 45%, transparent 80%)",
        }}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-48 bg-gradient-to-b from-transparent to-black sm:h-64"
      />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:py-20">
        <div className="flex flex-col gap-8 md:px-10 min-[1440px]:px-0">
          <div className="flex flex-wrap items-center justify-between gap-4">
            {/* Icon and wordmark are split so the wordmark can match rentSuccess's text size
                while the icon keeps its original rendered size. */}
            <div
              role="img"
              aria-label="rentDirect"
              className="flex h-[46px] items-center gap-1.5 pl-1 sm:h-[58px] sm:gap-[7px] sm:pl-[5px]"
            >
              <Image src="/logos/products/rentdirect-white-icon.png" alt="" width={208} height={166} className="h-[29px] w-auto sm:h-9" />
              <Image src="/logos/products/rentdirect-white-wordmark.png" alt="" width={371} height={64} className="h-[12.5px] w-auto sm:h-[15.5px]" />
            </div>
            <div
              role="tablist"
              aria-label="rentDirect view"
              className="flex items-center gap-1 rounded-full border border-white/15 bg-white/[0.06] p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.12),0_8px_24px_rgba(0,0,0,0.35)] backdrop-blur-xl"
            >
              {VIEWS.map((v) => {
                const selected = view === v.id;
                return (
                  <button
                    key={v.id}
                    type="button"
                    role="tab"
                    id={`rd-tab-${v.id}`}
                    aria-selected={selected}
                    aria-controls="rd-view-panel"
                    onClick={() => setView(v.id)}
                    className={`rounded-full px-4 py-2 font-sans text-sm font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#33F7BE] sm:px-5 ${
                      selected
                        ? "border border-white/20 bg-white/15 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]"
                        : "border border-transparent text-white/60 hover:text-white"
                    }`}
                  >
                    {v.label}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between lg:gap-12">
            <h2 className="max-w-2xl font-sans text-3xl font-normal leading-[1.05] tracking-tight text-white text-balance sm:text-4xl md:text-[44px]">
              {view === "front"
                ? "Your branded booking engine and guest experience."
                : "One Connected Ecosystem. Powering Your Brand."}
            </h2>
            <p className="max-w-md font-sans text-lg leading-relaxed text-white/70 text-pretty lg:text-right">
              {view === "front"
                ? "White-labeled booking experience under your brand, with seamless reservations, payments, guest management, and rental operations all in one place."
                : "Automated back-office operations built for online and in-person rentals across every type of renter."}
            </p>
          </div>
        </div>

        <div id="rd-view-panel" role="tabpanel" aria-labelledby={`rd-tab-${view}`} className="md:px-10 min-[1440px]:px-0">
          {view === "front" ? <HomeChannelCards /> : <HomeBuiltInDeckBare />}
        </div>
      </div>
    </div>
  );
}
